import { NgModule } from 'ng-metadata/core';
import { ProductRequirementsComponent } from './product-requirements.component';

@NgModule({
  declarations: [
    ProductRequirementsComponent,
  ],
})
export class ProductRequirementsModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/components/product-requirements/product-requirements.module.ts